import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { FullScreenLoadingBox } from 'components';
import { ROUTES } from 'core';
import { clearAfterLoginState, selectAfterLoginState } from 'store/user/userSlice';
import { useAppDispatch, useAppSelector } from 'store';

import { OidcContext } from '@britishcouncil/react-oidc-auth';

export const LogoutCallback = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const afterLoginState = useAppSelector(selectAfterLoginState);
  const userManager = OidcContext.useAuth();

  useEffect(() => {
    switch (afterLoginState) {
      case 'login':
        userManager.signinRedirect();
        break;
      case 'signup':
        navigate(ROUTES.SIGN_IN);
        break;
      default:
        navigate(ROUTES.COUNTRY_SELECTOR);
        break;
    }
    dispatch(clearAfterLoginState());
  }, []);

  return <FullScreenLoadingBox />;
};
